import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
//Components
import { Text, ImageContainer } from "../../atoms/index";
//import { ImageWrapper } from "../../../organisms/index";

const StudentCard = ({
  className,
  text,
  src,
  alt,
  imageBgColor,
  name,
  about,
  onFocus,
  onKeyDown
}) => {
  return (
    <div className={className} onFocus={onFocus} onKeyDown={onKeyDown}>
      <div className="col-auto">
        <div className="student-card" tabIndex={0}>
          <div className="text-container">
            <div className="content-container">
              <Text text={text} size="small" lineHeight="1.6rem" />
            </div>
          </div>
          <div className="row no-gutters">
            <div className="col-auto">
              <ImageContainer
                height="120px"
                width="120px"
                backgroundColor={imageBgColor}
                className="student-card__image"
                url={src}
              >
                {/*TODO Update the component, change imageContainer to a div and use imageWrapper*/}
                {/*
                <ImageWrapper
                  absoluteSize="120"
                  data={{ url: src }}
                  alt={alt}
                  height="100%"
                  width="100%"
                  endpoint={() => null}
                  hasEndpoint={false}
                  isVector={false}
                />
                 */}
              </ImageContainer>
            </div>
            <div className="col">
              <div className="name-container">
                <Text text={name} size="mediumSmall" fontWeight="500" />
                <Text text={about} size="small" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

StudentCard.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  name: PropTypes.string,
  about: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  imageBgColor: PropTypes.string,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func
};

StudentCard.defaultProps = {
  text: "Texto",
  src: "https://via.placeholder.com/120x120/eee/000",
  name: "Nome",
  about: "Aluno",
  onFocus: () => null,
  onKeyDown: () => null
};

const StudentCardWithStyles = styled(StudentCard)`
  .student-card {
    background-color: ${props => props.backgroundColor};
    outline-offset: -2px;
    &__image {
      div:first-child {
        height: inherit;
      }
    }

    :focus {
      outline: 2px solid ${props => props.focusColor};
    }

    .text-container {
      padding: 20px;
      border: 1px solid
        ${props => props.theme.components.studentCard.borderColor};
      height: 192px;
      .content-container {
        max-height: 150px;
        overflow: hidden;
      }
    }

    .name-container {
      padding: 20px;
    }
  }
`;

StudentCardWithStyles.defaultProps = {
  focusColor: "inherit"
};

export default StudentCardWithStyles;
